// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__ft5UX","signatureBlock":"Footer_signatureBlock__22y9h","signature":"Footer_signature__3pTS2"};